/**
 * 파일명 : Util.js
 * 작성자 : sangmin
 * 작성일 : 2021.02.19
 * 내용   : app에서 사용하는 util 함수를 관리한다.
 *
 * 수정이력 :
 */

const Util = {
  /**
   * null 여부를  체크하는 함수
   * ex) this.$Util.isNull(object)
   * @param {*} obj null 체크할 객체
   */
  isNull: function(obj) {
    if (!obj) return true;
    return false;
  },
  /**
   * 비어있는지의 여부를 체크하는 함수
   * ex) this.$Util.isEmpty(object)
   * @param {*} obj 비어있는지 체크할 객체
   */
  isEmpty: function(obj) {
    if (typeof obj !== "number") {
      if (this.isNull(obj)) return true;
      if (typeof obj === "object" && !Object.keys(obj).length) {
        return true;
      }
    }
    return false;
  },
  /**
   * 숫자타입인지를 체크하는 함수
   * ex) this.$Util.isNumber( value )
   * @param {*} value
   */
  isNumber: function(value) {
    const regxNum = /^[0-9]*$/;
    if (!regxNum.test(value)) {
      return false;
    }
    return true;
  },
  /**
   * 특수문자 포함 여부를 체크
   * @param {*} value 문자열
   * @return 0 : 특수문자포함, -1 : 특수문자 미포함
   */
  checkSpecial: function(value) {
    var regExp = /[{}[\]/?.,;:|)*~`!^\-_+&lt;&gt;@#$%&amp;\\=('"]/gi;
    if (regExp.test(value) == true) {
      return 0;
    } else {
      return -1;
    }
  },
  /**
   * 전화번호/휴대폰번호 형식인지 체크하는 함수
   * ex) this.$Util.isPhoneNumber(value)
   * @param {*} value
   */
  // isPhoneNumber: function(value) {
  //   const regxPhoneNumber = /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4}])/g;
  //   if (!regxPhoneNumber.test(value)) {
  //     return false;
  //   }
  //   return true;
  // },
  /**
   * 전화번호 체크 하는 함수
   * @param {*} phoneNum
   * @return true / false
   */
  isPhone: function(phoneNum) {
    let regExp = /(02)([0-9]{3,4})([0-9]{4})$/;
    //var myArray;
    if (regExp.test(phoneNum.replace(/-/g, ""))) {
      //myArray = regExp.exec(phoneNum);
      return true;
    } else {
      regExp = /(0[3-9]{1}[0-9]{1})([0-9]{3,4})([0-9]{4})$/;
      if (regExp.test(phoneNum.replace(/-/g, ""))) {
        //myArray = regExp.exec(phoneNum);
        return true;
      } else {
        return false;
      }
    }
  },
  /**
   * 휴대전화번호 여부 체크
   * @param {*} hpNum
   * @return true/false
   */
  isMobile: function(hpNum) {
    var regExp = /(01[016789])([1-9]{1}[0-9]{2,3})([0-9]{4})$/;
    //var myArray;
    if (regExp.test(hpNum.replace(/-/g, ""))) {
      //myArray = regExp.exec(hpNum);
      return true;
    } else {
      return false;
    }
  },
  /**
   * 전화번호 - format변경
   * @param {*} hpNum
   * @return true/false
   */
  makeFormatPhoneNum: function(hpNum) {
    let formatNum = "";

    if (hpNum.length == 11) {
      formatNum = hpNum.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    } else if (hpNum.length == 10) {
      formatNum = hpNum.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    } else {
      formatNum = hpNum;
    }
    return formatNum;
  },
  /**
   * 이메일 형식인지를 체크하는 함수
   * ex) this.$Util.isEmail(value)
   * @param {*} value
   */
  isEmail: function(value) {
    const regxEmail = /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/g;
    /* /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i; */
    if (!regxEmail.test(value)) {
      return false;
    }
    return true;
  },
  /**
   * 주민번호 형식인지를 체크하는 함수
   * ex) this.$Util.isJuminNumber(value)
   * @param {*} value
   */
  isJuminNumber: function(value) {
    const regxJuminNumber = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-4][0-9]{6}$/g;
    if (!regxJuminNumber.test(value)) {
      return false;
    }
    return true;
  },
  /**
   * 태그제거
   * ex) this.$Util.removeTag(value)
   * @param {*} value
   */
  removeTag: function(value) {
    const pattern = /(<([^>]+)>)/gi;
    let retVal;
    if (pattern.test(value)) {
      retVal = value.replace(pattern, "");
    }
    return retVal;
  },
  /**
   * 특수문자 태그 변환
   * ex) this.$Util.removeTag(value)
   * @param {*} value
   */
  replaceTag: function(value) {
    const arrTag = [
      { spec: "&lt;", tag: "<" },
      { spec: "&gt;", tag: ">" },
      { spec: "&amp;", tag: "&" },
      { spec: "&quot;", tag: '"' },
      { spec: "&#39;", tag: "'" },
      { spec: "&apos;", tag: "`" },
      { spec: "&nbsp;", tag: " " }
    ];

    let retVal = value;
    let pattern;
    arrTag.forEach(item => {
      pattern = new RegExp(item.spec, "g");
      retVal = retVal.replace(pattern, item.tag);
    });

    return retVal;
  },
  /**
   * 개행문자 <br/>로 변경
   * ex) this.$Util.replaceNewline(value)
   * @param {*} value
   */
  replaceNewline: function(value) {
    let pattern = /(\n|\r\n)/g;
    return value.replace(pattern, "<br/>");
  },
  /**
   * 날짜표시 포맷
   * @param {*} date : - 추가할 날짜 문자열
   *            formatVal : 포맷 문자열
   * @return - 추가된 문자열
   */
  formatDate: function(date, formatVal) {
    let formatedDate = "";
    let formatStr = "$1-$2-$3";

    if (date.length == 8) {
      if (!this.isEmpty(formatVal)) {
        formatStr = formatVal;
      }
      formatedDate = date.replace(/(\d{4})(\d{2})(\d{2})/, formatStr);
    } else {
      formatedDate = date;
    }

    return formatedDate;
  },
  /**
   * 통화표시 문자열
   * @param {*} currency : - 통화표시문자열
   * @return - 추가된 문자열
   */
  formatCurrency: function(curr) {
    let formatedCurr = "";
    formatedCurr = curr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatedCurr;
  },
  /**
   * 장학재단 계좌번호
   * @param {*} accno : - 계좌번호 문자열
   * @return - 추가된 문자열
   */
  formatAccnNo: function(accno) {
    let formatedAccno = "";
    if (accno.length == 16) {
      formatedAccno = accno.replace(
        /(\d{4})(\d{1})(\d{2})(\d{2})(\d{7})/,
        "$1-$2-$3-$4-$5"
      );
    } else {
      formatedAccno = accno;
    }
    return formatedAccno;
  },
  /**
   * 입력비밀번호의 유효성을 체크 한다.
   *
   * @param {*} id      비밀번호 체크 시 포함되지 않아야 할 문자열
   * @param {*} passwd  체크할 비밀번호
   * @return true/false
   */
  validatePassword: function(id, passwd) {
    if (!/^[a-zA-Z0-9]{8,20}$/.test(passwd)) {
      alert("비밀번호는 숫자와 영문자 조합으로 8~20자리를 사용해야 합니다.");
      return false;
    }
    var chk_num = passwd.search(/[0-9]/g);
    var chk_eng = passwd.search(/[a-z]/gi);
    if (chk_num < 0 || chk_eng < 0) {
      alert("비밀번호는 숫자와 영문자를 혼용하여야 합니다.");
      return false;
    }
    if (/(\w)\1\1\1/.test(passwd)) {
      alert("비밀번호에 같은 문자를 4번 이상 사용하실 수 없습니다.");
      return false;
    }
    if (passwd.search(id) > -1) {
      alert("ID가 포함된 비밀번호는 사용하실 수 없습니다.");
      return false;
    }
    return true;
  },
  /**
   * 추출대상 정보(string)로 부터 프로퍼티(prop)나 특정문자열(subString)이  존재하는지 확인하는 함수
   * userAgent로 부터 브라우저 정보를 추출한다.
   * @param {*} data
   */
  searchString: function(data) {
    for (var i = 0; i < data.length; i++) {
      var dataString = data[i].string;
      var dataProp = data[i].prop;
      this.versionSearchString = data[i].versionSearch || data[i].identity;
      if (dataString) {
        if (dataString.indexOf(data[i].subString) != -1)
          return data[i].identity;
      } else if (dataProp) return data[i].identity;
    }
  },
  /**
   * userAgent로 부터 브라우저 버전정보를 추출한다.
   * @param {*} dataString
   */
  searchVersion: function(dataString) {
    var index = dataString.indexOf(this.versionSearchString);
    if (index == -1) return;

    return dataString
      .substring(index + this.versionSearchString.length + 1)
      .split(" ")[0];
    // return parseFloat(
    //   dataString.substring(index + this.versionSearchString.length + 1)
    // );
  },
  /**
   * 접속 시스템 정보를 userAgent로 부터 추출하는 함수
   * this.$Util.browserDetect(
   *   this.$Const.dataBrowser,
   *   this.$Const.dataOS
   * )
   * @param {*} dataBrowser 추출시 비교대상 브라우저 정보 목록
   * @param {*} dataOS      추출시 비교대상 OS 정보 목록
   */
  browserDetect: function(dataBrowser, dataOS) {
    const browser = this.searchString(dataBrowser) || "An unknown browser";
    const version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "an unknown version";
    const OS = this.searchString(dataOS) || "an unknown OS";

    return {
      browser: browser,
      version: version,
      os: OS
    };
  },
  setStore: function(key, val) {
    //console.log("--저장값 타입: ", typeof val);
    if (typeof val == "string") {
      sessionStorage.setItem(key, val);
    } else {
      sessionStorage.setItem(key, JSON.stringify(val));
    }
  },
  getStore: function(key) {
    //console.log("--요청키값 : ", key);
    let retVal = null;
    var savedVal = sessionStorage.getItem(key);
    try {
      retVal = JSON.parse(savedVal);
    } catch (e) {
      retVal = savedVal;
    }

    return retVal;
  },
  removeStore: function(key) {
    sessionStorage.removeItem(key);
  },
  clearStore: function() {
    sessionStorage.clear();
  },
  printExpirationPeriod : function(timeLeft) {
    try {
      // timeLeft을 날짜 기준으로 변환
      let daysLeft = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      let hoursLeft = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutesLeft = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      let secondsLeft = Math.floor((timeLeft % (1000 * 60)) / 1000);

      // 3일 후 자정까지 남은 시간을 출력
      console.log("유효기간 : " + daysLeft + "일 " + hoursLeft + "시간 " + minutesLeft + "분 " + secondsLeft + "초");
    } catch (e) {
      console.log(e);
    }
  }
};

Util.install = function(Vue) {
  Vue.prototype.$Util = Util;
  Vue.prototype.log_error = function() {
    try {
      if (process.env.VUE_APP_LOGLEVEL >= this.$CONST.LOG_LEVEL_ERROR) {
        if (arguments.length > 0) {
          [].forEach.call(arguments, el => {
            console.log(el);
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  Vue.prototype.log_warning = function() {
    try {
      if (process.env.VUE_APP_LOGLEVEL >= this.$CONST.LOG_LEVEL_WARN) {
        if (arguments.length > 0) {
          [].forEach.call(arguments, el => {
            console.log(el);
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  Vue.prototype.log_info = function() {
    try {
      // args.forEach(el => {
      //   console.log(el);
      // });
      if (process.env.VUE_APP_LOGLEVEL >= this.$CONST.LOG_LEVEL_INFO) {
        if (arguments.length > 0) {
          [].forEach.call(arguments, el => {
            console.log(el);
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
  Vue.prototype.log_debug = function() {
    try {
      if (process.env.VUE_APP_LOGLEVEL >= this.$CONST.LOG_LEVEL_DEBUG) {
        if (arguments.length > 0) {
          [].forEach.call(arguments, el => {
            console.log(el);
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };
};

export default Util;
